import { defineMessages } from 'react-intl';

export default defineMessages({
    addPaymentMethod: {
        id: 'billing.paymentdetails.paymentOptions.Add New Payment Method',
        defaultMessage: 'Change Payment Details',
    },
    creditCard: {
        id: 'billing.paymentdetails.paymentOptions.Preauthorized Credit Card',
        defaultMessage: 'Preauthorized Credit Card',
    },
    bankAccount: {
        id: 'billing.paymentdetails.paymentOptions.Preauthorized Bank Account',
        defaultMessage: 'Preauthorized Bank Account',
    },
    addPayment: {
        id: 'billing.paymentdetails.paymentOptions.Add',
        defaultMessage: 'Add',
    },
    accountType: {
        id: 'billing.paymentdetails.paymentOptions.Bank Account Type',
        defaultMessage: 'Bank Account Type',
    },
    accountNumber: {
        id: 'billing.paymentdetails.paymentOptions.Bank Account Number',
        defaultMessage: 'Account Number',
    },
    routingNumber: {
        id: 'billing.paymentdetails.paymentOptions.Transit Number',
        defaultMessage: 'Transit Number',
    },
    bankHolderName: {
        id: 'billing.paymentdetails.paymentOptions.Bank Holder Name',
        defaultMessage: 'Bank Holder Name',
    },
    InstitutionNo: {
        id: 'billing.paymentdetails.paymentOptions.Institution Number',
        defaultMessage: 'Institution Number',
    },
    tooltipInstituteNo: {
        id: 'billing.paymentdetails.paymentOptions.Institution No tooltip msg',
        defaultMessage: 'The institution number - three digits - identifies your bank.',
    },
    tooltipTransitNo: {
        id: 'billing.paymentdetails.paymentOptions.Transit No tooltip msg',
        defaultMessage: 'The transit number - five digits - shows which branch you opened your account at.',
    },
    tooltipBankAccNo: {
        id: 'billing.paymentdetails.paymentOptions.BankAccNo tooltip msg',
        defaultMessage: 'The account number - seven to twelve digits - identifies your individual account.',
    },
    ValidateMsg: {
        id: 'billing.paymentdetails.paymentOptions.Validate',
        defaultMessage: 'Validate',
    },
    bankAccountNoInvalid: {
        id: 'billing.paymentdetails.paymentOptions.Bank account number should contain 7 to 12 digits',
        defaultMessage: 'Bank account number should contain 7 to 12 digits'
    },
    paymentMethodSaveFailed: {
        id: 'billing.paymentdetails.paymentOptions.Your payment method has not been saved',
        defaultMessage: 'Your payment method has not been saved'
    },
    paymentMethodSaveSuccess: {
        id: 'billing.paymentdetails.paymentOptions.Payment Method successfully added.',
        defaultMessage: 'Payment Method successfully added.'
    },
    fieldEmpty: {
        id: 'billing.paymentdetails.paymentOptions.Please fill all the mandatory fields.',
        defaultMessage: 'Please fill all the mandatory fields.'
    },
    automaticPaymentNA: {
        id: 'billing.paymentdetails.paymentOptions.This policy is not enrolled in automatic payments.',
        defaultMessage: 'This policy is not enrolled in automatic payments.'
    },
    failToLoadInvoiceDetails: {
        id: 'billing.paymentdetails.paymentOptions.Fail to load invoice details',
        defaultMessage: 'Fail to load invoice details'
    },
    cardHolderName: {
        id: 'billing.paymentdetails.paymentOptions.Cardholder Name',
        defaultMessage: 'Cardholder Name'
    },
    crditCardNumber: {
        id: 'billing.paymentdetails.paymentOptions.Credit Card Number',
        defaultMessage: 'Credit Card Number'
    },
    modeOfCardInfo: {
        id: 'billing.paymentdetails.paymentOptions.Mode Of Receiving Card Info',
        defaultMessage: 'Mode Of Receiving Card Info'
    },
    creditCardError: {
        id: 'billing.paymentdetails.paymentOptions.Credit Card Error',
        defaultMessage: 'Credit Card Error'
    },
    creditCardEmptyError: {
        id: 'billing.paymentdetails.paymentOptions.Please fill all credit card details',
        defaultMessage: 'Please fill all credit card details'
    },
    billingMethodChangeError: {
        id: 'billing.paymentdetails.paymentOptions.Please contact system administrator',
        defaultMessage: 'Unable to save billing method changes. Please contact system administrator'
    },
    paymentStatus: {
        id: 'billing.paymentdetails.paymentOptions.Payment Status',
        defaultMessage: 'Payment Status'
    },
    paymentAddFailure: {
        id: 'billing.paymentdetails.paymentOptions.Payment Add Failure',
        defaultMessage: 'Payment Add Failure'
    },
    paymentCycleMessageForMonths: {
        id: 'billing.paymentdetails.paymentOptions.Message for months',
        defaultMessage: 'On the {day} of every month for {month} months'
    },
    paymentCycleMessageForMonth: {
        id: 'billing.paymentdetails.paymentOptions.Message for month',
        defaultMessage: 'On the {day} of every month for {month} month'
    },
    paymentCycleUpdatedMessageForMonths: {
        id: 'billing.paymentdetails.paymentOptions.Updated Message for months',
        defaultMessage: 'Withdrawals will be made on the {day} of every month'
    }
});
